import http from "./httpServices";
import config from "./config.json";
import axios from "axios";

//Login & Register User Options
export const loginUser = (data) => {
  return;
};
export const registerUser = (data) => {
  return;
};
//End Login & Register User Options

//Record's Ticket Options and Replies Option
export const recordsTicket = (data, file) => {
  if (file) {
    const token = localStorage.getItem("token");
    const headers = {
      "Content-Type": "multipart/form-data",
      "x-access-token": token,
    };
    return axios.post(`${config.arzfi}/users/new-ticket-attached`, data, {
      headers: headers,
    });
  }
  return http.post(`${config.arzfi}/users/new-ticket`, data);
};

export const repliesToTicket = (data, file) => {
  if (file) {
    const token = localStorage.getItem("token");
    const headers = {
      "Content-Type": "multipart/form-data",
      "x-access-token": token,
    };
    return axios.post(`${config.arzfi}/users/ticket-reply-attached`, data, {
      headers: headers,
    });
  }
  return http.post(`${config.arzfi}/users/ticket-reply`, data);
};
//End Record's Ticket Options and Replies Option

export const usersTextTicket = (id) => {
  return http.get(`${config.arzfi}/users/ticket-details/${id}`);
};

export const usersProfile = () => {
  return http.get(`${config.arzfi}/users/profile`);
};

export const usersTickets = () => {
  return http.get(`${config.arzfi}/users/tickets`);
};

export const usersBalance = () => {
  return http.get(`${config.arzfi}/users/balance`);
};

export const coinUsersBalance = (coin) => {
  return http.get(`${config.arzfi}/users/balance/${coin}`);
};

export const addUsersNetworkWallet = (coin, network) => {
  return http.get(`${config.arzfi}/users/wallet/${coin}/${network}`);
};

export const usersTransactionsHistory = () => {
  return http.get(`${config.arzfi}/users/transactions`);
};

export const usersOrdersHistory = () => {
  return http.get(`${config.arzfi}/users/orders`);
};

export const usersCommisions = () => {
  return http.get(`${config.arzfi}/users/commissions`);
};

export const usersReferrals = () => {
  return http.get(`${config.arzfi}/users/refer`);
};

export const usersVerifyInfo = () => {
  return http.get(`${config.arzfi}/users/verify-data`);
};

///Create Two Fac Code and Check
export const usersCreateTwoFacCode = () => {
  return http.get(`${config.arzfi}/users/two-factor`);
};

export const usersCheckTwoFacCode = (data) => {
  const body = JSON.stringify(data);
  console.log(body);
  return http.post(`${config.arzfi}/users/check-gacode`, body);
};
///End Create Two Fac Code and Check

export const updateUsersDeposits = (item) => {
  return http.get(`${config.arzfi}/users/deposit/${item}`);
};
export const usersAddNewBankCard = (data) => {
  const body = JSON.stringify(data);
  return http.post(`${config.arzfi}/users/add_card`, body);
};
export const getUsersCards = () => {
  return http.get(`${config.arzfi}/users/cards`);
};
